import { PropsWithChildren, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from './store';

export function ProtectedRoute({ children }: PropsWithChildren) {
  const navigate = useNavigate();
  const setLoggedIn = useAuthStore((state) => state.setLoggedIn);
  const clear = useAuthStore((state) => state.clear);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function verifySession() {
      try {
        const res = await fetch('/api/tenants?limit=0', {
          credentials: 'same-origin',
        });

        if (cancelled) return;

        if (res.status === 401) {
          clear();
          navigate('/login', { replace: true });
          return;
        }

        if (!res.ok) {
          clear();
          navigate('/login', { replace: true });
          return;
        }

        setLoggedIn(true);
        setReady(true);
      } catch {
        if (cancelled) return;
        clear();
        navigate('/login', { replace: true });
      }
    }

    void verifySession();

    return () => {
      cancelled = true;
    };
  }, [clear, navigate, setLoggedIn]);

  if (!ready) return null;

  return <>{children}</>;
}
